
// 时间格式转换
export const vailTime = (datetime) => {
    function addDateZero (num) {
        return (num < 10 ? '0' + num : num)
    }
    const d = new Date(datetime)
    const formatdatetime = d.getFullYear() + '-' + addDateZero(d.getMonth() + 1) + '-' + addDateZero(d.getDate()) + ' ' + addDateZero(d.getHours()) + ':' + addDateZero(d.getMinutes()) + ':' + addDateZero(d.getSeconds())
    return formatdatetime
}
export const vailDay = (dateDay) => {
    function addDateZero (num) {
        return (num < 10 ? '0' + num : num)
    }
    const d = new Date(dateDay)
    const formatdatetime = d.getFullYear() + '-' + addDateZero(d.getMonth() + 1) + '-' + addDateZero(d.getDate())
    return formatdatetime
}

// 验证是否存在特殊符号
export const isSpecialChars = (rule, value, callback) => {
    const pattern = new RegExp(
        "[`~!@#$^&*=|{}':;,.<>/?~！@#￥……&*——|【】‘；：”“'。，、？%+ 　\"\\\\]"
    )
    let specialStr = ''
    for (let i = 0; i < value.length; i++) {
        specialStr += value.substr(i, 1).replace(pattern, '')
    }
    if (specialStr === value) {
        callback()
    } else {
        callback(new Error('名称不支持特殊符号，例如：/@<>|~!【】&%^?*'))
    }
}

// 验证密码
export const isPassword = (rule, value, callback) => {
    const exp = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*?])[\da-zA-Z~!@#$%^&*?]{8,12}$/
    if (value.length < 8 || value.length > 12) {
        callback(new Error('密码长度8-12位'))
    } else if (!exp.test(value)) {
        callback(new Error('必须包含字母、数字、特殊字符（~!@#$%^&*?）'))
    } else {
        callback()
    }
}
// 验证密钥对
export const isKeypair = (rule, value, callback) => {
    if (!/^[a-zA-Z0-9_]{1,}$/.test(value)) {
        callback(new Error('只能输入英文，数字，下划线'))
    } else {
        callback()
    }
}
// 验证手机号
export const isPhone = (rule, value, callback) => {
    const exp = /^(13[0-9]{9})|(18[0-9]{9})|(14[0-9]{9})|(17[0-9]{9})|(15[0-9]{9})|(19[0-9]{9})|(16[0-9]{9})$/
    if (value.length !== 11 || !exp.test(value)) {
        callback(new Error('手机号格式不正确'))
    } else {
        callback()
    }
}
export const notHttp = (rule, value, callback) => {
    const exp = /^(?!http:\/\/|https:\/\/).*/
    if (value && !exp.test(value)) {
        callback(new Error('不能以http://或者https://开头'))
    } else {
        callback()
    }
}

export const isCardNumber = (rule, value, callback) => {
    const exp = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
    if (!exp.test(value)) {
        callback(new Error('请输入正确的身份证号码'))
    } else {
        callback()
    }
}
export const isCardNumber15and18 = (rule, value, callback) => {
    const exp = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
    if (!exp.test(value)) {
        callback(new Error('请输入正确的身份证号码'))
    } else {
        callback()
    }
}
// 组装密码（'dec-'+随机4位+密码+随机4位）
export const assemblyPassword = (value) => {
    // 所需随机抽取的样本数组
    const nums = ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', 'a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'z', 'x', 'c', 'v', 'b', 'n', 'm', 'A', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P', 'A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'Z', 'X', 'C', 'V', 'B', 'N', 'M', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
    // 初始化 拼接字符串
    let str1 = ''
    let str2 = ''
    for (let i = 0; i < 4; i++) {
        const num = Math.floor(Math.random() * (0 - nums.length - 1) + (nums.length - 1))
        str1 += nums[num]
    }
    for (let i = 0; i < 4; i++) {
        const num = Math.floor(Math.random() * (0 - nums.length - 1) + (nums.length - 1))
        str2 += nums[num]
    }
    return 'dec-' + str1 + value + str2
}
